"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SkeletonTableRow = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = require("@chakra-ui/react");
var _react2 = _interopRequireDefault(require("react"));
var _constants = require("../constants");
var _jsxRuntime = require("react/jsx-runtime");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var SkeletonBox = _ref => {
  var {
    width = '100%',
    height = '20px',
    borderRadius = '4px'
  } = _ref;
  return (0, _jsxRuntime.jsx)(_react.Box, _objectSpread({
    width: width,
    height: height,
    borderRadius: borderRadius
  }, styles.skeletonBox));
};
var SkeletonTableRow = _ref2 => {
  var {
    isMobile,
    currentDates,
    index = 0
  } = _ref2;
  var hotelNameWidth = '75%';
  var priceWidth = '75%';
  return (0, _jsxRuntime.jsx)(_jsxRuntime.Fragment, {
    children: isMobile ? (0, _jsxRuntime.jsxs)(_react2.default.Fragment, {
      children: [(0, _jsxRuntime.jsx)(_react.Tr, _objectSpread(_objectSpread({
        bg: index % 2 === 0 ? _constants.THEME_COLORS.alternateRowBg : _constants.THEME_COLORS.primaryRowBg
      }, styles.mobileNameRow), {}, {
        children: (0, _jsxRuntime.jsx)(_react.Td, _objectSpread(_objectSpread({
          colSpan: currentDates.length + 2
        }, styles.mobileNameCell), {}, {
          children: (0, _jsxRuntime.jsx)(SkeletonBox, {
            width: hotelNameWidth,
            height: "20px"
          })
        }))
      })), (0, _jsxRuntime.jsxs)(_react.Tr, _objectSpread(_objectSpread({
        bg: index % 2 === 0 ? _constants.THEME_COLORS.alternateRowBg : _constants.THEME_COLORS.primaryRowBg
      }, styles.mobilePricesRow), {}, {
        children: [(0, _jsxRuntime.jsx)(_react.Td, _objectSpread({
          "data-testid": "skeleton-spacer-left-".concat(index)
        }, styles.spacerCell)), currentDates.map((_, idx) => (0, _jsxRuntime.jsx)(_react.Td, _objectSpread(_objectSpread({}, styles.mobilePriceCell), {}, {
          children: (0, _jsxRuntime.jsx)(SkeletonBox, {
            width: priceWidth,
            height: "16px",
            borderRadius: "4px"
          })
        }), idx)), (0, _jsxRuntime.jsx)(_react.Td, _objectSpread({
          "data-testid": "skeleton-spacer-right-".concat(index)
        }, styles.spacerCell))]
      }))]
    }) : (0, _jsxRuntime.jsxs)(_react.Tr, _objectSpread(_objectSpread({
      bg: index % 2 === 0 ? _constants.THEME_COLORS.alternateRowBg : _constants.THEME_COLORS.primaryRowBg
    }, styles.desktopRow), {}, {
      children: [(0, _jsxRuntime.jsx)(_react.Td, _objectSpread(_objectSpread({
        "data-testid": "skeleton-hotel-name-".concat(index)
      }, styles.desktopNameCell), {}, {
        children: (0, _jsxRuntime.jsx)(SkeletonBox, {
          width: hotelNameWidth,
          height: "20px"
        })
      })), (0, _jsxRuntime.jsx)(_react.Td, {
        "data-testid": "skeleton-spacer-left-".concat(index)
      }), currentDates.map((_, idx) => (0, _jsxRuntime.jsx)(_react.Td, _objectSpread(_objectSpread({}, styles.desktopPriceCell), {}, {
        children: (0, _jsxRuntime.jsx)(SkeletonBox, {
          width: priceWidth,
          height: "16px",
          borderRadius: "4px"
        })
      }), idx)), (0, _jsxRuntime.jsx)(_react.Td, {
        "data-testid": "skeleton-spacer-right-".concat(index)
      })]
    }))
  });
};
exports.SkeletonTableRow = SkeletonTableRow;
var styles = {
  skeletonBox: {
    bg: '#EEEEEE',
    position: 'relative',
    overflow: 'hidden',
    _before: {
      content: '""',
      position: 'absolute',
      top: 0,
      left: '-100%',
      width: '100%',
      height: '100%',
      background: 'linear-gradient(90deg, transparent, rgba(255,255,255,0.6), transparent)',
      animation: 'shimmer 1.8s infinite ease-in-out'
    },
    sx: {
      '@keyframes shimmer': {
        '0%': {
          left: '-100%'
        },
        '50%': {
          left: '100%'
        },
        '100%': {
          left: '100%'
        }
      }
    }
  },
  mobileNameRow: {
    sx: {
      borderBottom: 'none'
    }
  },
  mobileNameCell: {
    fontWeight: 'semibold',
    fontSize: {
      base: 'sm',
      md: 'md'
    },
    textAlign: 'left',
    px: 2,
    py: 1,
    sx: {
      overflow: 'hidden',
      whiteSpace: 'nowrap',
      textOverflow: 'ellipsis',
      borderTopLeftRadius: '8px',
      borderTopRightRadius: '8px',
      borderBottom: 'none'
    }
  },
  mobilePricesRow: {
    sx: {
      borderTop: 'none',
      borderBottomLeftRadius: '8px',
      borderBottomRightRadius: '8px'
    }
  },
  mobilePriceCell: {
    textAlign: 'center',
    sx: {
      borderTop: 'none'
    },
    minW: '34px',
    w: '44px',
    fontSize: {
      base: 'xs',
      md: 'sm'
    },
    p: {
      base: '2px',
      md: '2'
    }
  },
  spacerCell: {
    sx: {
      borderTop: 'none'
    }
  },
  desktopRow: {
    transition: 'background-color 0.2s ease'
  },
  desktopNameCell: {
    fontWeight: 'semibold',
    scope: 'row',
    fontSize: {
      base: 'xs',
      md: 'sm'
    },
    w: '50%',
    sx: {
      overflow: 'hidden',
      whiteSpace: 'nowrap',
      textOverflow: 'ellipsis'
    }
  },
  desktopPriceCell: {
    textAlign: 'center',
    minW: 'calc(50% / 7)',
    w: 'calc(50% / 7)',
    fontSize: {
      base: 'xs',
      md: 'sm'
    }
  }
};